import { render, staticRenderFns } from "./PremiumPage.vue?vue&type=template&id=b10e0d68&scoped=true"
import script from "./PremiumPage.vue?vue&type=script&lang=js"
export * from "./PremiumPage.vue?vue&type=script&lang=js"
import style0 from "./PremiumPage.vue?vue&type=style&index=0&id=b10e0d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e0d68",
  null
  
)

export default component.exports